///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ReminderIcon = ({
  height,
  fill = "#FFFFFF",
  title = messages.reminder.defaultMessage,
  width,
  secondaryColor = "#B00020",
  ...rest
}) => (
  <svg
    aria-labelledby="reminder-icon"
    width={width}
    height={height}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    {...rest}
  >
    <title id="reminder-icon">{title}</title>
    <defs>
      <path
        d="M22 6l-5-4-1 1 5 4 1-1zM8 3L7 2 2 6l1 1 5-4zm5 5h-2v6l5 3 1-1-4-3V8zm-1-4a9 9 0 100 18 9 9 0 000-18zm0 16a7 7 0 110-14 7 7 0 010 14z"
        id="reminder-icon-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle fill={secondaryColor} cx="18" cy="18" r="18" />
      <g transform="translate(6 6)">
        <path d="M0 0h24v24H0z" />
        <mask id="reminder-icon-mask" fill={fill}>
          <use xlinkHref="#reminder-icon-path" />
        </mask>
        <use fill="#000" xlinkHref="#reminder-icon-path" />
        <g mask="url(#reminder-icon-mask)" fill={fill}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default ReminderIcon;
